import { render, staticRenderFns } from "./SuccessBuyModal.vue?vue&type=template&id=1fe69410"
import script from "./SuccessBuyModal.vue?vue&type=script&lang=js"
export * from "./SuccessBuyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports